module.exports = {
  qbankURL: "https://qbank.ideaboard.in",
  accountsURL: "https://accounts.ideaboard.in",
  ibWebDomain: "https://www.ideaboard.in",
  razorPayPublicKey: "rzp_live_kPnZZLgPnRiKz3",
};
